export const deepCopyMap = (map: Map<any, any>): Map<any, any> => {
  return new Map(JSON.parse(JSON.stringify(Array.from(map))));
};

export const getTotalEelementsCount = (map: Map<any, any>): number => {
  let numberOfElements = 0;
  Array.from(map.keys()).forEach(
    (x) => (numberOfElements += map.get(x)?.length ?? 0)
  );
  return numberOfElements;
};
